























import Vue from 'vue';
import { Component, PropSync } from 'vue-property-decorator';

@Component({})
export default class FeatureTab extends Vue {
	@PropSync('feature') public featureProp: {
		russia: {
			twoWeekSwitchEnabled: boolean,
			regimeChart: {
				title: string,
				valueYes: string,
				valueNo: string,
			},
		},
	};
}
